import React from 'react';
import { Link } from 'react-router-dom';

const Breadcrumbs = ({ crumbs }) => {
    if (crumbs.length <= 1) {
        return null; // No need for breadcrumbs if there's only one item
    }

    return (
        <nav className="text-gray-700 text-sm font-semibold py-3" aria-label="Breadcrumb"> 
            <ol className="list-none p-0 inline-flex">
                {crumbs.map((crumb, index) => {
                    const isLast = index === crumbs.length - 1;
                    return (
                        <li key={index} className={`${isLast ? 'text-gray-900' : 'text-blue-600 hover:text-blue-700'} ${index > 0 ? 'ml-4' : ''}`}>
                            {isLast ? (
                                crumb.label
                            ) : (
                                <Link to={crumb.path} className="flex items-center">
                                    {crumb.label}
                                    <svg className="fill-current w-3 h-3 mx-3" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 111.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z" /></svg>
                                </Link>
                            )}
                        </li>
                    );
                })}
            </ol>
        </nav>
    );
};

export default Breadcrumbs;
